import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import Loaders from '@/product/components/molecules/Loaders'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/product/context/setting/settingContext'
import SettingCustomContext from '@/custom/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
import CountryManager from './countryManager'

const Country = () => {
    const settingcontext = useContext(SettingContext)
    const settingCustomContext = useContext(SettingCustomContext)
    const usercommoncontext = useContext(UserCommonContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const { allLocations, getGlobalVariable } = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(false)

    const {
        searchTableFetch,
        searchTableAction,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext
    // const {
    //     searchGroupTable,
    //     group_table_data,
    //     searchTableAction,
    //     responseStatus: responseStatusSetting,
    //     clearResponse: clearResponseCommuncation,
    // } = settingCustomContext

    const { getPreviousData, clearPreviousData, previous_data } =
        usercommoncontext

    const [changeStatus, setChangeStatus] = useState(false)

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        record: {},
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formikSelection = useFormik({
        initialValues: {
            status: 0,
            id: 0,
            table: 'data_country',
            global_publisher: true,
            updateDataCountry: true,
            // where: 'factory_code',
        },
        onSubmit: (values) => {
            setIsLoading(true)
            values.updateDataCountry = true
            searchTableAction(values, false, 'country_delete')
        },
    })
    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'country_create' &&
                responseStatusSetting.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                setTimeout(() => {
                    searchTableFetch(formikView.values, 'country')
                    setIsLoading(true)
                }, 2000)
            } else if (
                responseStatusSetting.from === 'country_delete' &&
                responseStatusSetting.status === 'success'
            ) {
                setTimeout(() => {
                    searchTableFetch(formikView.values, 'country')
                    // setIsLoading(false)
                }, 2000)
                setChangeStatus(false)
            }
            clearResponseCommuncation()
        }
    }, [responseStatusSetting])

    const formikView = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            primaryTable: 'data_country',
            orderby: 'coun.name,asc',
            filters: true,
            filters: {
                name: {
                    value: '',
                    type: 'like',
                    field: 'coun.name',
                },
                status: {
                    value: 1,
                    type: 'in',
                    field: 'coun.status',
                },
            },
        },
        onSubmit: (values) => {
            searchTableFetch(values, 'country')
        },
    })

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'country') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
                setIsLoading(false)
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        searchTableFetch(formikView.values, 'country')
    }, [])

    const onClickEdit = (id, secondaryID, type) => {
        if (type == 'delete') {
            formikSelection.values.id = id
            setChangeStatus(!changeStatus)
        } else {
            toggleFullScreenPopup(true, type, id)
        }
    }

    const getMultipleAction = () => {
        let actionPush = []
        actionPush.push({
            buttonType: 'edit',
            clickType: 'edit',
            onclick: onClickEdit,
            tooltipTitle: 'Edit',
        })

        actionPush.push({
            buttonType: 'delete',
            clickType: 'delete',
            onclick: onClickEdit,
            tooltipTitle: 'Delete',
        })

        return actionPush
    }

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
            filterable: true,
            filterField: 'id',
        },
        {
            field: 'name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Country Name',
            filterable: true,
            filterField: 'name',
        },
        {
            field: 'isoCode',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'IsoCode',
            filterable: true,
            filterField: 'isoCode',
        },
        {
            field: 'IsoAlpha3Code',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'IsoAlpha3Code',
            filterable: true,
            filterField: 'IsoAlpha3Code',
        },
        {
            field: 'IsoNumericCode',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'IsoNumericCode',
            filterable: true,
            filterField: 'IsoNumericCode',
        },
        {
            field: 'CigarWatchCountry',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'CigarWatchCountry',
            filterable: true,
            filterField: 'CigarWatchCountry',
        },
        {
            field: 'BuyerWatchCountry',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'BuyerWatchCountry',
            filterable: true,
            filterField: 'BuyerWatchCountry',
        },
        {
            field: 'SellerWatchCountry',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'SellerWatchCountry',
            filterable: true,
            filterField: 'SellerWatchCountry',
        },
        {
            field: 'TobaccoAge',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'TobaccoAge',
            filterable: true,
            filterField: 'TobaccoAge',
        },
        {
            field: 'Territory_EU',
            type: 'condition',
            condition: true,
            conditionValue: {
                formula: {
                    isString: true,
                    key1: 'Territory_EU',
                    key2: 1,
                    notation: '==',
                },
                true: {
                    type: 'text',
                    value: 'Yes',
                },
                false: {
                    type: 'text',
                    value: 'No',
                },
            },
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Territory EU',
            filterable: true,
            filterField: 'Territory_EU',
        },
        {
            field: 'Payment_Type',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Payment Type',
            filterable: true,
            filterField: 'Payment_Type',
        },
        {
            field: 'Allow_Bids',
            type: 'condition',
            condition: true,
            conditionValue: {
                formula: {
                    isString: true,
                    key1: 'Allow_Bids',
                    key2: 1,
                    notation: '==',
                },
                true: {
                    type: 'text',
                    value: 'Yes',
                },
                false: {
                    type: 'text',
                    value: 'No',
                },
            },
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Allow Bids',
            filterable: true,
            filterField: 'Allow_Bids',
        },
        {
            field: 'Allow_Listings',
            type: 'condition',
            condition: true,
            conditionValue: {
                formula: {
                    isString: true,
                    key1: 'Allow_Listings',
                    key2: 1,
                    notation: '==',
                },
                true: {
                    type: 'text',
                    value: 'Yes',
                },
                false: {
                    type: 'text',
                    value: 'No',
                },
            },
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Allow Listings',
            filterable: true,
            filterField: 'Allow_Listings',
        },
        // {
        //     field: 'currency',
        //     type: '',
        //     firstChild: true,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Currency',
        //     filterable: true,
        //     filterField: 'currency',
        // },
        {
            name: 'action',
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
            tableShow: 1,
        },
    ]

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        if (
            action === 'active' ||
            action === 'deactive' ||
            action === 'delete'
        ) {
            if (action === 'delete') {
                getPreviousData({
                    page: 1,
                    limit: 20,
                    order: '',
                    orderby: '',
                    primaryTable: 'projects',
                    customTable: 'custom_projects',
                    similars: {
                        category: {
                            value: formikSelection.values.id,
                            type: 'arrayin',
                            field: 'p.location_id',
                        },
                    },
                })
            } else if (action === 'deactive') {
                setChangeStatus(true)
            } else {
                setChangeStatus(true)
            }
        }
    }

    useEffect(() => {
        if (previous_data) {
            if (previous_data.records.length) {
                setAlert('Previous records exists!', 'error')
                formikSelection.values.action = ''
                formikSelection.values.id = 0
                clearPreviousData()
            } else if (formikSelection.values.action) {
                setChangeStatus(true)
            }
        }
    }, [previous_data])

    const tableActions = []
    // tableActions.push(
    //     {
    //         label: 'Move to Active',
    //         icon: <span className="material-icons">check_circle</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'active',
    //     },
    //     {
    //         label: 'Move to Deactive',
    //         icon: <span className="material-icons">block</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'deactive',
    //     },
    //     {
    //         label: 'Delete Permanently',
    //         icon: <span className="material-icons">cancel</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'delete',
    //     }
    // )

    const searchInfo = [
        {
            label: 'Enter Country Name',
            placeholder: 'Enter Country Name',
            class: 'col-md-4 col-sm-6 col-12',
            type: '',
            name: 'name',

            filter: true,
            formik: formikView,
        },
        // {
        //     label: 'Enter Factory Name',
        //     placeholder: 'Enter Factory Name',
        //     class: 'col-md-4 col-sm-6 col-12',
        //     type: '',
        //     name: 'factory_name',

        //     filter: true,
        //     formik: formikView,
        // },
    ]

    return (
        <Layout>
            <div className="dashboard staticPages">
                <CustomSearch searchInfo={searchInfo} formik={formikView} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <Button
                        id="location_add"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add New
                        Country
                    </Button>
                </div>
                {isLoading ? (
                    <div className="fspLoader">
                        <Loaders isLoading={isLoading} />
                    </div>
                ) : (
                    <CustomTable
                        formik={formikView.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={tableActions}
                        allData={search_fetch_data}
                        changeTableFunction={searchTableFetch}
                        fromVariable={'country'}
                    />
                )}
            </div>
            <CountryManager
                record={search_fetch_data?.records}
                data={manage}
                setLoading={setIsLoading}
                function={toggleFullScreenPopup}
            />

            <CustomDialog
                title={'Confirm'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to delete ?</h5>
                <div className="actionWrapper">
                    <Button
                        id="location_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="location_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default Country
